<script setup>
  import ComponentCategoryBadge from "@components/Badges/CategoryBadge.vue";

  defineOptions({
    name: "MergeAccountStep",
  });

  defineProps({
    currentAccount: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <li class="relative flex-1 rounded-md border-1 p-4 shadow-md md:p-2 md:pb-4 lg:p-4">
    <ComponentCategoryBadge v-if="currentAccount" color="green" label="eingeloggt" class="absolute top-2 right-2" />
    <slot />
  </li>
</template>
